import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  messageIncomingList: {
    status: StateStatus | null;
    data: any;
  };
  memberStateExcludeCyprusList: any;
  xmlMessage: {
    status: StateStatus | null;
    data: any;
  };
}

const initialState: IState = {
  messageIncomingList: {
    status: null,
    data: null,
  },
  memberStateExcludeCyprusList: {
    status: null,
    data: null,
  },
  xmlMessage: {
    status: null,
    data: null,
  },
};

const MessageIncomingReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_MESSAGE_INCOMING_LIST:
      return {
        ...state,
        messageIncomingList: {
          ...state.messageIncomingList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.messageIncomingList.data
              : action.data,
        },
      };
    case Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS:
      return {
        ...state,
        memberStateExcludeCyprusList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.GET_MESSAGE_INCOMING_XML:
      return {
        ...state,
        xmlMessage: {
          status: action.status || null,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default MessageIncomingReducer;
